import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import NoAccessMessage from './NoAccessMessage';

const AdminProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isLoading } = useAuth0();
  if (isLoading) return null;
  const roles = (user && Array.isArray(user["https://bespot.com/roles"]) ? user["https://bespot.com/roles"] : []) as string[];
  const isAdmin =
    roles.includes("admin") ||
    roles.includes("superadmin") ||
    roles.includes("support") ||
    roles.includes("enterprise_role");
  if (!isAdmin) return <NoAccessMessage />;
  return <>{children}</>;
};

export default AdminProtectedRoute; 